module.exports = __webpack_public_path__ + "img/arrow-left.66623863.svg";